export const isWechat = () => {
  let ua = window.navigator.userAgent
  if (/miniprogram/i.test(ua)) {
    return true
  }
  return false
}

export const googletagmanagerInit = () => {
  if (!isWechat()) {
    var script = document.createElement("script")
    script.type = "text/javascript"
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-8YZBB3X6LT"
    document.getElementsByTagName("head")[0].appendChild(script)

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MKMS6C8K" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);

    script.onload = () => {
      // 需要初始化sdk环境，等等...
      (function(w,d,s,l,i){
        w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MKMS6C8K');
    }

    noscript.onload = () => {
      // 需要初始化sdk环境，等等...
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-8YZBB3X6LT');
    }

  }
}